const NavBarItems = [
  {
    title: 'About',
    url: 'about',
    cName: 'nav-links'
  },
  {
    title: 'Experience',
    url: 'experience',
    cName: 'nav-links'
  },
  {
    title: 'Portfolio',
    url: 'portfolio',
    cName: 'nav-links'
  },
  {
    title: 'Skills',
    url: 'skills',
    cName: 'nav-links'
  },
  {
    title: 'Contact',
    url: 'contact',
    cName: 'nav-links'
  },
]

export default NavBarItems;